export const INITIALIZE_FILTERS = 'INITIALIZE_FILTERS'
export const ADD_FILTER = 'ADD_FILTER'
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT'
export const REMOVE_FILTER = 'REMOVE_FILTER'
export const UPDATE_SELECTED_FILTERS = 'UPDATE_SELECTED_FILTERS'
export const SET_CLUBS = 'SET_CLUBS'
